import { Icon, IconProps } from '../Icon'

export const ArrowDropUpIcon = ({ color, size }: IconProps) => {
  return (
    <Icon color={color} size={size}>
      arrow_drop_up
    </Icon>
  )
}
